/**
 * @generated SignedSource<<923d8d111f089da40e732904396be181>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomRatesTableRateEditor_packageDate$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableRateEditorForm_packageDate">;
  readonly " $fragmentType": "RoomRatesTableRateEditor_packageDate";
};
export type RoomRatesTableRateEditor_packageDate$key = {
  readonly " $data"?: RoomRatesTableRateEditor_packageDate$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableRateEditor_packageDate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomRatesTableRateEditor_packageDate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoomRatesTableRateEditorForm_packageDate"
    }
  ],
  "type": "PackageDate",
  "abstractKey": null
};

(node as any).hash = "1cab2357cb88ec8f27542a80fd39cc2d";

export default node;
